import { useState } from "react";
import { confirmDialog } from "primereact/confirmdialog";
import { createSideUpdater } from "../../utils/createSideUpdater";

const useEditorMarking = ({
  pengecekanBerangkatData,
  pengecekanKembaliData,
  pengecekanBerangkatDetilData,
  setPengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  setPengecekanKembaliDetilData,
  deleteDetil,
  kendaraanJenisFilter
}) => {
  // update the detil rows of one side ("berangkat" or "kembali")
  const updateDetilList = createSideUpdater({
    berangkat: pengecekanBerangkatDetilData,
    setBerangkat: setPengecekanBerangkatDetilData,
    kembali: pengecekanKembaliDetilData,
    setKembali: setPengecekanKembaliDetilData,
  });

  // dialog state
  const [optionSelectorAdditionalFilter, setOptionSelectorAdditionalFilter] =
    useState("");
  const [pengecekanMobilOptionDialogData, setPengecekanMobilOptionDialogData] =
    useState({});
  const [showPengecekanMobilOptionDialog, setShowPengecekanMobilOptionDialog] =
    useState(false);

  // handle UI event section

  const handleOnClickAddMarking = ({ field, type }) => {
    setOptionSelectorAdditionalFilter(
      `label_grup:=:${field};kendaraan_jenis_id:${kendaraanJenisFilter}`
    );
    setPengecekanMobilOptionDialogData({ label_grup: field, type: type });
    setShowPengecekanMobilOptionDialog(true);
  };

  const handleOnChangeKordinat = ({ type, id, marking_kordinat }) => {
    updateDetilList(type.toString(), (list) =>
      list.map((detil) => {
        // a marking not saved yet (staged by Beri Tanda) has no id: it is matched by _localId instead
        if ((detil.id || detil._localId) === id) {
          return { ...detil, marking_kordinat, _dirty: true };
        }
        return detil;
      })
    );
  };

  // adding a marking (Beri Tanda) only stages it locally - it has no id yet, so it does not exist on the server
  // until the Save button below (saveDetilMany) sends it
  const handleOnConfirmPengecekanMobilOption = (e, option) => {
    if (option && option.length > 0) {
      const { type, label_grup } = pengecekanMobilOptionDialogData;

      // pengecekanBerangkatData/pengecekanKembaliData are undefined until the header loads (a first-time record
      // is still being created), so this can run before either exists
      const gambar =
        type === "kembali"
          ? pengecekanKembaliData?.[label_grup]
          : pengecekanBerangkatData?.[label_grup];

      const singleOption = option[0];

      setShowPengecekanMobilOptionDialog(false);

      // get new urutan
      // find max urutan from pengecekanBerangkatDetilData or pengecekanKembaliDetilData based on type
      // filter by label_grup
      // and get new urutan from max + 1
      let urutan = 1;
      const _detailList = (
        type === "berangkat"
          ? pengecekanBerangkatDetilData
          : pengecekanKembaliDetilData
      ).filter((detil) => detil.label_grup === singleOption.label_grup);
      if (_detailList && _detailList.length > 0) {
        const maxUrutan = Math.max(..._detailList.map((d) => d.urutan));
        urutan = maxUrutan + 1;
      }

      const _newDetil = {
        // client-only: identifies this row until it is saved and gets a real id (see mergeSavedMarkingDetils)
        _localId: `new-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        pengecekan_mobil_id:
          type === "berangkat"
            ? pengecekanBerangkatData?.id
            : pengecekanKembaliData?.id,
        pengecekan_mobil_option_id: singleOption.id,
        urutan: urutan,
        type: type === "berangkat" ? 1 : 2,
        keterangan: singleOption.keterangan,
        cek: 0,
        label_grup: singleOption.label_grup,
        gambar: gambar,
        marking_warna: "rgb(225,29,72)",
        marking_kordinat: "0.5,0.5",
      };

      updateDetilList(type, (list) => [...list, _newDetil]);
    }
  };

  const handleOnClickRemoveMarking = async ({ data, type }) => {
    confirmDialog({
      message: `Menghapus penanda nomor #${data.urutan}, lanjutkan?`,
      header: "Konfirmasi Hapus",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => {
        if (data.id) {
          deleteDetil({ id: data.id, type });
        } else {
          // never saved (staged by Beri Tanda): just drop it locally, nothing to delete on the server
          updateDetilList(type, (list) =>
            list.filter((detil) => detil._localId !== data._localId)
          );
        }
      },
    });
  };

  return {
    showPengecekanMobilOptionDialog,
    setShowPengecekanMobilOptionDialog,
    optionSelectorAdditionalFilter,
    pengecekanMobilOptionDialogData,
    handleOnClickAddMarking,
    handleOnChangeKordinat,
    handleOnConfirmPengecekanMobilOption,
    handleOnClickRemoveMarking
  };
};

export default useEditorMarking;
